import React from 'react';
import PropTypes from 'prop-types';
import { useDataModel } from '@thd-nucleus/data-sources';
import { normalizePromoVisNavData } from '../utils/normalizePromoVisNavData';
import { promoVisNavDataModel } from './dataModel';
import { PromoVisualNavigationRenderer } from './PromoVisualNavigationRenderer';

const PromoVisualNavigation = ({
  componentId = '',
  slotContentId: slotName = '',
  componentClass = '',
  componentPosition = 1,
  experienceHasSideNav = false,
  title = '',
  lazyLoad = false,
  enableTheme = false,
  isHomePage = false,
  fontWeight = 'display',
  enableHomepageGap = false,
  enableFullBleed = false,
  enableB2CRadius = false,
  mediaCollectionIndex = 0
}) => {
  const { data: componentData, loading: componentLoading, error: componentError } = useDataModel('component', {
    variables: {
      id: componentId,
      componentClass: 'PromoVisualNavigation'
    },
    skip: !!slotName
  });

  const { data: slotData, loading: slotLoading, error: slotError } = useDataModel('slot', {
    fetchPolicy: 'cache-only',
    variables: { id: slotName },
    skip: !slotName
  });

  const normalizedData = normalizePromoVisNavData({ slotData, componentData, mediaCollectionIndex });

  if (componentLoading || componentError || slotLoading || slotError || !normalizedData) {
    return null;
  }

  const { dataComponent, items } = normalizedData;

  // Return null if no items to display
  if (!items || items.length === 0) {
    return null;
  }

  return (
    <PromoVisualNavigationRenderer
      componentId={componentId || dataComponent?.id}
      componentClass={componentClass}
      componentPosition={componentPosition}
      experienceHasSideNav={experienceHasSideNav}
      title={title || dataComponent?.title || ''}
      lazyLoad={lazyLoad}
      enableTheme={enableTheme}
      isHomePage={isHomePage}
      dataComponent={dataComponent}
      promoVisNavList={items}
      fontWeight={fontWeight}
      enableHomepageGap={enableHomepageGap}
      enableFullBleed={enableFullBleed}
      enableB2CRadius={enableB2CRadius}
    />
  );
};

PromoVisualNavigation.displayName = 'PromoVisualNavigation';
PromoVisualNavigation.propTypes = {
  componentId: PropTypes.string,
  slotContentId: PropTypes.string,
  componentClass: PropTypes.string,
  componentPosition: PropTypes.number,
  experienceHasSideNav: PropTypes.bool,
  title: PropTypes.string,
  lazyLoad: PropTypes.bool,
  enableTheme: PropTypes.bool,
  isHomePage: PropTypes.bool,
  fontWeight: PropTypes.string,
  enableHomepageGap: PropTypes.bool,
  enableFullBleed: PropTypes.bool,
  enableB2CRadius: PropTypes.bool,
  mediaCollectionIndex: PropTypes.number
};

PromoVisualNavigation.dataModel = promoVisNavDataModel;

export { PromoVisualNavigation };
